var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group",class:(_vm.customClass + " " + _vm.darkMode)},[_vm._l((_vm.items),function(item){return [_c('li',{key:item.id,staticClass:"list-group-item",class:_vm.darkMode},[_vm._v(_vm._s(item.title))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }